module.exports = __webpack_public_path__ + "public-ui/fonts/vietnamese.38263f69.woff2";